module.exports = "/_next/static/resources/wv-wide-9b67f09f2f55b3d40e54e2b651f00c50.webp";